// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CompactView__container-e09529 {
  width: 360px;
  height: 100vh;
  display: grid;
  grid-template-columns: auto minmax(360px, 1fr) auto;
  grid-auto-rows: 100%;
}`, "",{"version":3,"sources":["webpack://./src/main/RightSidebarManager/components/CompactView/CompactViewCalendar.styles.m.css"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,aAAA;EACA,aAAA;EACA,mDAAA;EACA,oBAAA;AACF","sourcesContent":[".container {\n  width: 360px;\n  height: 100vh;\n  display: grid;\n  grid-template-columns: auto minmax(360px, 1fr) auto;\n  grid-auto-rows: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `CompactView__container-e09529`
};
module.exports = ___CSS_LOADER_EXPORT___;
